import React from 'react';
import classNames from 'classnames';

const FormText = ({type = 'text', small, value, onChange, disabled, className, ...props}) => (
    <>
        <input {...props} disabled={disabled} type={type} className={classNames(className, 'form-control', {'form-control-sm': small})} value={value} onChange={event => onChange(event.target.value)}/>
    </>
);

export default FormText;